import { render, staticRenderFns } from "./WidgetAssigned.vue?vue&type=template&id=55996666"
import script from "./WidgetAssigned.vue?vue&type=script&lang=js"
export * from "./WidgetAssigned.vue?vue&type=script&lang=js"
import style0 from "./WidgetAssigned.vue?vue&type=style&index=0&id=55996666&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports